import { handleActions, createAction } from 'redux-actions';

export const SET_LOADER = createAction('SET/LOADER');

const initialState = {
  isLoading: false,
};

const LoaderReducer = handleActions(
  {
    [SET_LOADER]: (state, { payload: { value, }, }) => {
      return { ...state, isLoading: value, };
    },
  },
  initialState
);

export default LoaderReducer;
